"use client"

import { useFormikContext } from "formik"

import { FormInput } from "@/components/form-inputs"
import { normalizeWebsiteUrlInput } from "@/lib/ai/knowledge-base/url-import/url"

type WebsiteUrlFormValues = {
  url: string
}

type WebsiteUrlFormInputProps = {
  placeholder: string
  disabled?: boolean
}

export function WebsiteUrlFormInput({ placeholder, disabled = false }: WebsiteUrlFormInputProps) {
  const { values, setFieldTouched, setFieldValue } = useFormikContext<WebsiteUrlFormValues>()

  return (
    <FormInput
      name="url"
      label="Website URL"
      placeholder={placeholder}
      inputMode="url"
      autoCapitalize="none"
      autoCorrect="off"
      disabled={disabled}
      onBlur={() => {
        void setFieldTouched("url", true, false)
        void setFieldValue("url", normalizeWebsiteUrlInput(values.url), true)
      }}
    />
  )
}
